import * as types from './mutation_types';

let actions = {
    // 设置购物车数据
    setCartData ({commit}, cartData) {
        commit('SET_CART_DATA', cartData);

        let {cartItems} = cartData;

        cartItems = cartItems || [];

        commit('SET_CART_LIST', cartItems);
    },
    // 显示toast提示框
    showToast ({commit}, text) {
        commit('SET_TOAST_SHOW');
        commit('SET_TOAST_TEXT', text);
        setTimeout(() => {
            commit('SET_TOAST_HIDE');
            commit('SET_TOAST_TEXT', '');
        }, 2600)
    },
    // 显示confirm弹窗
    showConfirm({commit}, data) {
        commit(types.SET_CONFIRM_SHOW);
        commit(types.SET_CONFIRM_DATA, data);
    }
};

export default actions;



// WEBPACK FOOTER //
// ./src/store/actions.js